import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Dropzone from 'react-dropzone';
import FileDrop from 'react-file-drop';

import { uploadFile } from '../../api/simplApi';
import FileList from '../../components/FileList/FileList';
import classes from './FormFileUpload.scss';
import moment from 'moment';

class FormFileUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadState: 100,
    };
    this.lastUpload = moment();
  }

  onDrop = filesToUpload => {
    const now = moment();
    if (now.diff(this.lastUpload) < 300) {
      // avoids double upload problem
      return;
    }

    this.lastUpload = moment();

    const filesArray = Array.isArray(filesToUpload)
      ? filesToUpload
      : Array.from(filesToUpload);

    uploadFile(
      filesArray,
      data => {
        const files = _.cloneDeep(this.props.files);

        data.forEach(file => {
          files.push(file);
        });

        if (this.props.avatar) {
          this.props.onUpdate(files[0].id);
        } else {
          this.props.onUpdate(files);
        }
      },
      percentage => {
        // gets the upload percentage returned
        this.setState({ uploadState: percentage });
      },
      {
        attachableId: this.props.attachableId,
        attachableType: this.props.attachableType,
      },
    );
  };

  onDelete = fileId => {
    const files = _.cloneDeep(this.props.files);
    this.props.onUpdate(_.remove(files, file => file.id !== fileId));
  };

  renderUploadProgress = () => {
    if (this.state.uploadState > 99) {
      return <div className={`${classes.uploadBar} ${classes.empty}`} />;
    }
    return (
      <div className={`${classes.uploadBar}`}>
        <div
          className={classes.filling}
          style={{ width: `${this.state.uploadState}%` }}
        >
          <span>{this.state.uploadState}%</span>
        </div>
      </div>
    );
  };

  renderFullWindow = () => (
    <div>
      <FileDrop frame={document} onDrop={this.onDrop}>
        <div className={classes.dropIt}>Dateien hier ablegen</div>
      </FileDrop>
    </div>
  );

  render() {
    if (this.props.invisible) {
      if (!this.props.disabled) {
        return this.renderFullWindow();
      } else {
        return <div />;
      }
    }

    if (this.props.avatar) {
      let delDiv = <div />;

      if (this.props.avatarUrl.length) {
        delDiv = (
          <div
            onClick={() => {
              this.props.onUpdate(null);
            }}
            className={classes.delete}
          >
            Bild löschen
          </div>
        );
      }

      return (
        <div>
          <Dropzone
            onDrop={this.onDrop}
            multiple
            className="dropzone"
            style={{ backgroundImage: `url(${this.props.avatarUrl})` }}
          >
            <div>
              Hier klicken um ein
              <br />
              neues Foto hochzuladen
            </div>
          </Dropzone>
          {delDiv}
        </div>
      );
    }

    return (
      <div>
        <FileList files={this.props.files} onDelete={this.onDelete} />

        {this.renderUploadProgress()}

        <br />

        <Dropzone onDrop={this.onDrop} multiple className="dropzone">
          <div>{this.props.uploadText}</div>
        </Dropzone>

        {this.renderFullWindow()}
      </div>
    );
  }
}

FormFileUpload.propTypes = {
  files: PropTypes.array.isRequired,
  onUpdate: PropTypes.func.isRequired,
  avatar: PropTypes.bool,
  avatarUrl: PropTypes.string,
  attachableId: PropTypes.string,
  attachableType: PropTypes.string,
  invisible: PropTypes.bool,
  disabled: PropTypes.bool,
  uploadText: PropTypes.string,
};

FormFileUpload.defaultProps = {
  files: [],
  avatar: false,
  avatarUrl: '',
  attachableId: '',
  attachableType: '',
  invisible: false,
  disabled: false,
  uploadText: 'Dateien in dieses Feld ziehen oder hier klicken',
};

export default FormFileUpload;



// WEBPACK FOOTER //
// ./src/components/FormFileUpload/FormFileUpload.js